import Icon from '../components/Icon.vue'

Icon.register({
  'book-dead': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M272 136c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM448 358.4c0 9.6-3.2 16-9.6 19.2-3.2 12.8-3.2 57.6 0 73.6 6.4 6.4 9.6 12.8 9.6 19.2v16c0 16-12.8 25.6-25.6 25.6h-326.4c-54.4 0-96-41.6-96-96v-320c0-54.4 41.6-96 96-96h326.4c16 0 25.6 9.6 25.6 25.6v332.8zM240 56c-44.2 0-80 28.7-80 64 0 20.9 12.7 39.2 32 50.9v13.1c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-13.1c19.3-11.7 32-30 32-50.9 0-35.3-35.8-64-80-64zM124.8 223.3c-1.7 4.1 0.1 8.8 4.2 10.5l70.5 30.3-70.4 30.1c-4.1 1.7-5.9 6.4-4.2 10.5l6.3 14.7c1.7 4.1 6.4 5.9 10.5 4.2l98.3-42.2 98.3 42.1c4.1 1.7 8.8-0.1 10.5-4.2l6.3-14.7c1.7-4.1-0.1-8.8-4.2-10.5l-70.3-30.1 70.3-30.2c4.1-1.7 5.9-6.4 4.2-10.5l-6.3-14.7c-1.7-4.1-6.4-5.9-10.5-4.2l-98.4 42.1-98.3-42.1c-4.1-1.7-8.8 0.1-10.5 4.2zM380.8 448v-64h-284.8c-16 0-32 12.8-32 32s12.8 32 32 32h284.8zM208 136c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/book-dead.js
// module id = 674
// module chunks = 0